import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from '../shared/text/Text'
import { CURRENCIES } from '../../constants/app'
import { formatTicks } from '../../util/string.helpers'
import GridData from '../shared/data/GridData'

const ParticipationDetails = ({
  title,
  price,
  ticketsBought,
  ticketsWon,
  qbxAmount,
  t
}) => {
  const data = [
    {
      label: t('results.ticket-price'),
      value: `${formatTicks(price)} ${CURRENCIES.DEFAULT}`,
      valueStyles: { textAlign: 'left' },
      isValueBold: false
    },
    {
      label: t('results.tickets-bought'),
      value: formatTicks(ticketsBought),
      valueStyles: { textAlign: 'left' }
    },
    {
      label: t('results.tickets-won'),
      value: formatTicks(ticketsWon),
      valueStyles: { textAlign: 'left' }
    },
    {
      label: t('results.qbx-received'),
      value: `${formatTicks(qbxAmount)} ${CURRENCIES.QBX}`,
      valueStyles: { textAlign: 'left' }
    }
  ]
  return (
    <Stack gap={1}>
      <Text label={t(`results.${title}`)} fontWeight={700} fontSize='1.25rem' />
      <GridData data={data} />
    </Stack>
  )
}

export default memo(ParticipationDetails)
